<template>
  <Modal headerType="fail" :visible="visible" @close="handleClickClose">
    <div class="content">
      <div class="title">很遗憾你没有中奖～</div>
      <img class="icon" src="../assets/images/sad-face.png" />
      <div class="okBtn" @click="handleClickOk">我知道了</div>
    </div>
  </Modal>
</template>

<script>
import Modal from './Modal';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Modal
  },
  watch: {
    visible: function(newVal, oldVal) {
      if (newVal && !oldVal) {
        // 埋点
        this.reportExpo();
      }
    }
  },
  methods: {
    handleClickOk() {
      this.$emit('close');
    },
    handleClickClose() {
      this.$emit('close');
    },
    reportExpo() {
      this.visitLog('', '', {
        actEventType: 'activity_topic_popup_expo',
        module_name: '未中奖弹窗'
      });
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  font-size: 40px;
  color: #333;
}

.icon {
  margin: 75px 0;
  width: 185px;
  height: 185px;
}

.okBtn {
  margin-top: 18px;
  margin-bottom: 50px;
  width: 450px;
  height: 88px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: normal;
  background: linear-gradient(to top, #ff7e00 0%, #ff9600 39%, #ffb80f 99%);
  border-radius: 44px;
  font-size: 40px;
  color: #fff;
}
</style>
